import { render, staticRenderFns } from "./AddCompanyToCompanyPage.vue?vue&type=template&id=22c55446&scoped=true"
import script from "./AddCompanyToCompanyPage.vue?vue&type=script&lang=js"
export * from "./AddCompanyToCompanyPage.vue?vue&type=script&lang=js"
import style0 from "./AddCompanyToCompanyPage.vue?vue&type=style&index=0&id=22c55446&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c55446",
  null
  
)

export default component.exports